import {Frontend} from "./frontend";

(function () {
    XonBoard.DynamicSensorReads = {
        list: {

            selectors: {
                sensor_reads_table: $('#sensor-reads-table'),
                count_label: $('#count-label'),
            },

            init: function (keys, fresh) {
                if (fresh) {
                    this.selectors.sensor_reads_table = $('#sensor-reads-table');
                    this.selectors.count_label = $('#count-label');
                }


                let columns = [
                    {data: 'received_date', name: 'sensor_reads.received_date', createdCell: this.renderCell,},
                ];
                for(let index in keys) {
                    let key = keys[index];
                    if(key == 'payload') {
                        continue;
                    }

                    columns.push(
                        {
                            data: key,
                            name: 'sensor_reads.values->' + key,
                            createdCell: this.renderCell,
                        }
                    );
                }
                columns.push(
                    {data: 'actions', name: 'actions', searchable: false, sortable: false, createdCell: this.renderCell,}
                );

                let self = this;
                let table = this.selectors.sensor_reads_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.sensor_reads_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsTotal);
                            return json.data;
                        },
                        data(d) {
                            const from_datetime = $('#from_datetime').val();
                            if (from_datetime) {
                                d.from_datetime = from_datetime;
                            }

                            const to_datetime = $('#to_datetime').val();
                            if (to_datetime) {
                                d.to_datetime = to_datetime;
                            }
                        },
                    },
                    columns: columns,
                    order: [[0, "desc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
            renderCell(td, cellData) {
                if(cellData && cellData.value != null) {
                    $(td).addClass(cellData.class);
                    $(td).html(cellData.value);
                    return;
                }

                $(td).html(cellData);
            }
        },
    }
})();
